"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SendReminderModalController = /** @class */ (function () {
    function SendReminderModalController($uibModalInstance, DocumentInstanceModel, FlashService, document, pendingUsers) {
        var _a;
        this.$uibModalInstance = $uibModalInstance;
        this.DocumentInstanceModel = DocumentInstanceModel;
        this.FlashService = FlashService;
        this.document = document;
        this.pendingUsers = pendingUsers;
        this.submitting = false;
        var documentName = ((_a = this.document.template) === null || _a === void 0 ? void 0 : _a.name) || "this document";
        this.message = "";
    }
    SendReminderModalController.prototype.submit = function () {
        var _this = this;
        if (this.submitting) {
            return;
        }
        var userIds = this.pendingUsers.map(function (u) { return u.user_id; });
        var data = {
            user_ids: userIds,
        };
        if (this.message) {
            data.message = this.message;
        }
        this.submitting = true;
        this.DocumentInstanceModel.sendReminder(this.document.id, data)
            .then(function () {
            _this.$uibModalInstance.close();
        })
            .catch(function () {
            _this.FlashService.setMessage({
                type: "error",
                message: "Failed to send reminder",
            });
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    SendReminderModalController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss("cancel");
    };
    SendReminderModalController.prototype.getRoleLabel = function (role) {
        var labels = {
            student: "Student",
            guardian: "Guardian",
            instructor: "Instructor",
            staff: "Staff",
        };
        return labels[role] || role;
    };
    return SendReminderModalController;
}());
SendReminderModalController.$inject = [
    "$uibModalInstance",
    "DocumentInstanceModel",
    "FlashService",
    "document",
    "pendingUsers",
];
exports.default = SendReminderModalController;
